/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  FETCH_SD_EXTERNALUSER_RENEWAL_STATUS,
  FETCH_SD_RENEWAL_APPLICATION_FORM,
  FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM,
} from './actionTypes';

/**
 * Updates the details in the 'UserRenewals' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdExternaluserRenewalStatusReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_EXTERNALUSER_RENEWAL_STATUS);

/**
 * Updates the indicator of creation of details in the 'UserRenewals' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdExternaluserRenewalStatusReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_EXTERNALUSER_RENEWAL_STATUS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdExternaluserRenewalStatusErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_EXTERNALUSER_RENEWAL_STATUS);

/**
 * Updates the details in the 'UserRenewals' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdRenewalApplicationFormReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_RENEWAL_APPLICATION_FORM);

/**
 * Updates the indicator of creation of details in the 'UserRenewals' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdRenewalApplicationFormReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_RENEWAL_APPLICATION_FORM);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdRenewalApplicationFormErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_RENEWAL_APPLICATION_FORM);

/**
 * Updates the details in the 'UserRenewals' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdccaCcaRenewalApplicationFormReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM);

/**
 * Updates the indicator of creation of details in the 'UserRenewals' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdccaCcaRenewalApplicationFormReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdccaCcaRenewalApplicationFormErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SDCCA_CCA_RENEWAL_APPLICATION_FORM);

const reducers = combineReducers({
  fetchSdExternaluserRenewalStatus: fetchSdExternaluserRenewalStatusReducer,

  isFetchingFetchSdExternaluserRenewalStatus: isFetchingFetchSdExternaluserRenewalStatusReducer,
  fetchSdExternaluserRenewalStatusError: fetchSdExternaluserRenewalStatusErrorReducer,

  fetchSdRenewalApplicationForm: fetchSdRenewalApplicationFormReducer,

  isFetchingFetchSdRenewalApplicationForm: isFetchingFetchSdRenewalApplicationFormReducer,
  fetchSdRenewalApplicationFormError: fetchSdRenewalApplicationFormErrorReducer,

  fetchSdccaCcaRenewalApplicationForm: fetchSdccaCcaRenewalApplicationFormReducer,

  isFetchingFetchSdccaCcaRenewalApplicationForm:
    isFetchingFetchSdccaCcaRenewalApplicationFormReducer,
  fetchSdccaCcaRenewalApplicationFormError: fetchSdccaCcaRenewalApplicationFormErrorReducer,
});

export default { reducers };
